import React from "react";
import styles from "./Sources.module.scss";

type Props = {
  title: string;
  url: string;
  imageUrl?: string;
  site?: string;
  date?: string;
};

export const SourceCard: React.FC<Props> = ({ title, url, imageUrl, site, date }) => {
  return (
    <a className={styles.card} href={url} target="_blank" rel="noopener noreferrer">
      <div className={styles.thumbWrap}>
        {imageUrl ? (
          <img className={styles.thumb} src={imageUrl} alt={title} loading="lazy" />
        ) : (
          <div className={styles.noThumb} />
        )}
      </div>

      <div className={styles.meta}>
        <div className={styles.title} title={title}>{title}</div>
        <div className={styles.sub}>
          {site && <span className={styles.site}>{site}</span>}
          {site && date && <span className={styles.dot}>&middot;</span>}
          {date && <time className={styles.date}>{new Date(date).toLocaleDateString()}</time>}
        </div>
      </div>
    </a>
  );
};
